import { useEffect, useState } from "react";
import api from "@/lib/api";
import { MapPin, ShieldCheck, Clock, Navigation, Landmark } from "lucide-react";

export default function Addresses() {
  const [points, setPoints] = useState([]);

  useEffect(() => {
    api.get("/addresses").then(({ data }) => setPoints(data)).catch(() => {});
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 lg:px-8 py-10 lg:py-14">
      <div className="max-w-2xl">
        <div className="inline-flex items-center gap-2 label-mono text-crimson mb-2"><MapPin size={15} /> Campus pickup points</div>
        <h1 className="font-display font-extrabold text-ink text-3xl lg:text-4xl tracking-tight">Verified handoff locations</h1>
        <p className="mt-3 text-slate-500 text-lg leading-relaxed">
          Every deal happens at one of these safe, high-traffic spots inside SRM KTR. Sellers pick a point when
          finalizing a sale in chat — so you always know exactly where to meet.
        </p>
      </div>

      <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {points.map((p, i) => (
          <div
            key={p.id}
            className="group bg-white border border-slate-200 rounded-xl overflow-hidden hover:shadow-[0_8px_30px_rgba(15,23,42,0.08)] transition-all animate-fade-up"
            style={{ animationDelay: `${i * 0.04}s` }}
            data-testid={`address-card-${p.id}`}
          >
            <div className="relative h-28 bg-ink grid-texture grid place-items-center">
              <div className="absolute inset-0 grid-texture opacity-30" />
              <div className="relative h-12 w-12 rounded-full bg-white/10 border border-white/20 grid place-items-center">
                <Landmark size={22} className="text-white" />
              </div>
              <span className="absolute top-3 left-3 label-mono text-[9px] text-white/70">{p.zone}</span>
            </div>
            <div className="p-5">
              <h3 className="font-display font-semibold text-ink text-lg leading-snug">{p.name}</h3>
              <div className="mt-3 space-y-2 text-sm text-slate-600">
                <div className="flex items-start gap-2">
                  <Navigation size={14} className="text-brand mt-0.5 shrink-0" />
                  <span>{p.landmark}</span>
                </div>
                <div className="flex items-center gap-2">
                  <Clock size={14} className="text-slate-400 shrink-0" />
                  <span>{p.hours}</span>
                </div>
                <div className="flex items-center gap-2">
                  <ShieldCheck size={14} className="text-emerald-500 shrink-0" />
                  <span className="text-emerald-700">{p.safety_level}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-10 rounded-xl border border-amber-200 bg-amber-50 p-5 flex items-start gap-3">
        <ShieldCheck size={20} className="text-amber-600 mt-0.5 shrink-0" />
        <div className="text-sm text-amber-800">
          <span className="font-semibold">Safety first.</span> Only meet at these listed points during their open hours.
          Never share OTPs, and never pay or accept payment outside the platform.
        </div>
      </div>
    </div>
  );
}
